<template>
	<div class="dateTime">
		<div v-if="date" class="date">{{ date }}</div>
		<div v-if="time" class="time">{{ time }}</div>
	</div>
</template>
<script>

export default {
	name: "DateTime2",
	props: {
		date: String,
		time: String
	}
};
</script>

<style scoped lang="scss">
.dateTime {
	.date {
		color: var(--card-color);
	}
	.time {
		color: var(--card-color-sub-title);
		font-size: 12px;
	}
}

</style>
